'use client';

import { c as _c } from "react/compiler-runtime";
import { getJsonCookieRecordValue, isTimestampWithinDays, setJsonCookieRecordTimestamp } from '@repo/utility/json-cookie-record';
import { useCallback, useEffect, useState } from 'react';
const CTA_DISMISS_COOKIE_KEY = 'dismiss-live-location-cta';
const CTA_DISMISS_DAYS = 7;

/**
 * `isSuppressed` reflects the dismissal cookie at load (and on title change) and intentionally does
 * NOT flip when `markSeen` runs, so the promo stays put for the session and only disappears on the
 * next load within the 7-day window.
 */
export function useLiveLocationCtaSuppression(titleKey) {
  const $ = _c(8);
  const [isSuppressed, setIsSuppressed] = useState(true);
  let t0;
  let t1;
  if ($[0] !== titleKey) {
    t0 = () => {
      if (!titleKey) {
        setIsSuppressed(true);
        return;
      }
      const dismissedAt = getJsonCookieRecordValue(CTA_DISMISS_COOKIE_KEY, titleKey);
      setIsSuppressed(isTimestampWithinDays(dismissedAt, CTA_DISMISS_DAYS));
    };
    t1 = [titleKey];
    $[0] = titleKey;
    $[1] = t0;
    $[2] = t1;
  } else {
    t0 = $[1];
    t1 = $[2];
  }
  useEffect(t0, t1);
  let t2;
  if ($[3] !== titleKey) {
    t2 = () => {
      if (!titleKey) {
        return;
      }
      setJsonCookieRecordTimestamp(CTA_DISMISS_COOKIE_KEY, titleKey, CTA_DISMISS_DAYS);
    };
    $[3] = titleKey;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  const markSeen = t2;
  let t3;
  if ($[5] !== isSuppressed || $[6] !== markSeen) {
    t3 = {
      isSuppressed,
      markSeen
    };
    $[5] = isSuppressed;
    $[6] = markSeen;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  return t3;
}